import { z } from 'zod'

import { LOGIC_OPERATOR } from 'modules/shift_management/hooks/reducers/filter'

const DAYS_TO_GENERATE = 6
export const GENERATION_METHODS = {
  from_shifts: 'from_shifts',
  previous_coverage: 'previous_coverage',
} as const

const schema = z.object({
  customFilters: z.array(z.string()).optional().nullable(),
  daysToGenerate: z.number().default(7),
  employeeIds: z.array(z.number()).optional().nullable(),
  logicOperator: z.enum(['and', 'or']).optional().nullable(),
  originalStartAt: z.date(),
  targetStartAt: z.date(),
  locationIds: z.array(z.number()).optional().nullable(),
  generationMethod: z
    .enum([GENERATION_METHODS.from_shifts, GENERATION_METHODS.previous_coverage])
    .default(GENERATION_METHODS.from_shifts),
})

export type SchemaType = z.infer<typeof schema>

export const GenerateCoverageForm = () => {
  const defaultValues: SchemaType = {
    daysToGenerate: DAYS_TO_GENERATE,
    originalStartAt: new Date(),
    targetStartAt: new Date(),
    locationIds: undefined,
    generationMethod: GENERATION_METHODS.from_shifts,
    customFilters: [],
    employeeIds: [],
    logicOperator: LOGIC_OPERATOR.AND,
  }

  return {
    defaultValues,
    schema,
  }
}
